import filter from "@domains/utils/filter";
import { totalDaysPnlPerc, totalPnlPerc } from "@domains/utils/holdings";
import { findObjectsByValue } from "@domains/utils/search";
import sort, { ESortOrder, stringSort } from "@domains/utils/sort";
import summarize from "@domains/utils/summarize";
export default class HoldingCommonUseCase {
    constructor(searchUsecase, filterUsecase, sortUseCase, summarizeUseCase, dashboardSummarizeUseCase) {
        this.searchUsecase = searchUsecase;
        this.filterUsecase = filterUsecase;
        this.sortUseCase = sortUseCase;
        this.summarizeUseCase = summarizeUseCase;
        this.dashboardSummarizeUseCase = dashboardSummarizeUseCase;
    }
    async dashboardSummarize(dashboardData, isSummarize) {
        return await this.dashboardSummarizeUseCase.getSummarizedData(dashboardData, isSummarize);
    }
    async getModifiedData(holdingReportData, combinedState) {
        try {
            let searchData = await this.searchUsecase.getSearchData(holdingReportData, combinedState.searchState);
            let filterData = await this.filterUsecase.getFilteredData(searchData, combinedState.filterUiState);
            let sortedData = await this.sortUseCase.getSortedData(filterData, combinedState.sortDataUiState);
            let summerizeData = await this.summarizeUseCase.getSummarizedData(sortedData, combinedState.isSummarize);
            return summerizeData;
        }
        catch (error) {
            console.log(error);
        }
    }
}
export class SearchUseCase {
    getSearchData(holdingReportData, searchData) {
        const HoldingDetails = findObjectsByValue(holdingReportData.HoldingDetails, searchData);
        return Object.assign(Object.assign({}, holdingReportData), { HoldingDetails, SearchData: searchData });
    }
}
export class FilterUseCase {
    getFilteredData(holdingReportData, { simpleFilter, assetFilter, productAssetFilter }) {
        var _a, _b;
        let summary;
        let FilterData = [];
        var isAssetFiltersApplied = false;
        var isSimpleFiltersApplied = false;
        var isProductFilterAppiled = false;
        const filterStateForProductAssests = [{ key: ["quote", "edelweissProductCode"], value: [] }];
        const filterStateForAssests = [{ key: ["quote", "assetCode"], value: [] }];
        assetFilter.filters.forEach((filter) => {
            if (filter.selected) {
                isAssetFiltersApplied = true;
                filterStateForAssests[0].value.push(filter.key);
            }
        });
        if (isAssetFiltersApplied) {
            FilterData = filter(holdingReportData.HoldingDetails, filterStateForAssests);
        }
        productAssetFilter === null || productAssetFilter === void 0 ? void 0 : productAssetFilter.filters.forEach((filter) => {
            if (filter.selected) {
                isProductFilterAppiled = true;
                filterStateForProductAssests[0].value.push(filter.key);
            }
        });
        if (isProductFilterAppiled) {
            FilterData = filter(isAssetFiltersApplied ? FilterData : holdingReportData.HoldingDetails, filterStateForProductAssests);
        }
        const simpleFilterState = [];
        simpleFilter.filters.forEach((filter) => {
            if (filter.selected) {
                isSimpleFiltersApplied = true;
                simpleFilterState.push({
                    key: ["filterFlags", filter.key],
                    value: true,
                });
            }
        });
        if (isSimpleFiltersApplied) {
            FilterData = filter(isAssetFiltersApplied || isProductFilterAppiled
                ? FilterData
                : holdingReportData.HoldingDetails, simpleFilterState);
        }
        // if (
        //   isSimpleFiltersApplied &&
        //   (isAssetFiltersApplied || isProductFilterAppiled)
        // ) {
        //   var mergedData = simpleFilterData.concat(
        //     assetFilterData,
        //     productassetFilterData
        //   );
        //   filteredData = mergedData.filter((item, index) => {
        //     return mergedData.indexOf(item) == index;
        //   });
        // } else if (isSimpleFiltersApplied) {
        //   filteredData.push(...simpleFilterData);
        // } else if (isAssetFiltersApplied) {
        //   filteredData.push(...assetFilterData);
        // } else {
        //   filteredData = holdingReportData.HoldingDetails;
        // }
        if (isSimpleFiltersApplied ||
            isAssetFiltersApplied ||
            isProductFilterAppiled) {
            let totalInvestment = 0, currentValue = 0, totalPnL = 0, daysPnL = 0;
            FilterData.map((x) => {
                totalInvestment = totalInvestment + Number(x.investmentValue);
                currentValue = currentValue + Number(x.currentValue);
                totalPnL = totalPnL + Number(x.pnl);
                daysPnL = daysPnL + Number(x.dayChange);
            });
            summary = Object.assign(Object.assign({}, holdingReportData.HoldingSummary), { totalInvestment,
                currentValue,
                totalPnL,
                daysPnL, totalPnLChange: totalPnlPerc(totalPnL, totalInvestment), daysPnLChange: totalDaysPnlPerc(daysPnL, (_b = (_a = holdingReportData === null || holdingReportData === void 0 ? void 0 : holdingReportData.HoldingSummary) === null || _a === void 0 ? void 0 : _a.totalPreviousClosingValue) === null || _b === void 0 ? void 0 : _b.valueOf()) });
        }
        else {
            FilterData = holdingReportData.HoldingDetails;
            summary = holdingReportData.HoldingSummary;
        }
        return Object.assign(Object.assign({}, holdingReportData), { HoldingDetails: FilterData, HoldingSummary: summary, FilterData: { simpleFilter, assetFilter, productAssetFilter } });
    }
}
export class SortUseCase {
    getSortedData(data, sortState) {
        let HoldingDetails;
        if (sortState.sortName == "displayName") {
            HoldingDetails = stringSort(data.HoldingDetails, sortState.sortName, sortState.order);
        }
        else {
            HoldingDetails = sort(data.HoldingDetails, sortState.sortName, sortState.order);
        }
        let SortData = data.SortData.map((e) => (Object.assign(Object.assign({}, e), { order: sortState.sortName === e.sortName
                ? sortState.order
                : ESortOrder.UNCHANGED })));
        return Object.assign(Object.assign({}, data), { HoldingDetails,
            SortData });
    }
}
export class SummarizedUseCase {
    async getSummarizedData(data, isSummarize) {
        if (isSummarize) {
            let { HoldingSummary, HoldingDetails, IsSummarize } = data;
            HoldingSummary = Object.assign(Object.assign({}, HoldingSummary), { totalInvestment: summarize(Number(HoldingSummary.totalInvestment)), currentValue: summarize(Number(HoldingSummary.currentValue)), totalPnL: summarize(Number(HoldingSummary.totalPnL)), daysPnL: summarize(Number(HoldingSummary.daysPnL)) });
            HoldingDetails = HoldingDetails.map((HoldingDetail) => {
                return Object.assign(Object.assign({}, HoldingDetail), { averagePrice: summarize(HoldingDetail.averagePrice), CUSA: summarize(HoldingDetail.cusa), currentValue: summarize(HoldingDetail.currentValue), dayChange: summarize(HoldingDetail.dayChange), freeQuantity: summarize(HoldingDetail.freeQuantity), investmentValue: summarize(HoldingDetail.investmentValue), lasPledge: summarize(HoldingDetail.lasPledge), lockedInQuantity: summarize(HoldingDetail.lockedInQuantity), mtfPledge: summarize(HoldingDetail.mtfPledge), normalMarginPledge: summarize(HoldingDetail.normalMarginPledge), pnl: summarize(HoldingDetail.pnl), quantity: summarize(HoldingDetail.quantity), safeKeepQuantity: summarize(HoldingDetail.safeKeepQuantity), sebiMtfHoldQuantity: summarize(HoldingDetail.sebiMtfHoldQuantity), soldQuantity: summarize(HoldingDetail.soldQuantity), t1: summarize(HoldingDetail.t1), t1Mtf: summarize(HoldingDetail.t1Mtf), tradableQuantity: summarize(HoldingDetail.tradableQuantity) });
            });
            IsSummarize = isSummarize;
            return Promise.resolve(Object.assign(Object.assign({}, data), { HoldingSummary,
                HoldingDetails,
                IsSummarize }));
        }
        return data;
    }
}
export class DashboardHoldingSummarizedUseCase {
    async getSummarizedData(data, isSummarize) {
        if (isSummarize) {
            const summarizeDashboard = data.holdingDashboardSummary.map((x) => {
                return Object.assign(Object.assign({}, x), { investmentValue: summarize(Number(x.investmentValue)), marketValue: summarize(Number(x.marketValue)), pnl: summarize(Number(x.pnl)) });
            });
            const holdingSummary = Object.assign(Object.assign({}, data.holdingSummary), { totalInvestment: summarize(Number(data.holdingSummary.totalInvestment)), currentValue: summarize(Number(data.holdingSummary.currentValue)), totalPnL: summarize(Number(data.holdingSummary.totalPnL)), daysPnL: summarize(Number(data.holdingSummary.daysPnL)) });
            return Object.assign(Object.assign({}, data), { holdingDashboardSummary: summarizeDashboard, holdingSummary: holdingSummary });
        }
        return data;
    }
}
